<template>
  <div class="unselectable">
    <h1 class="title has-text-centered">รายละเอียดการสนับสนุน</h1>
    <div class="columns is-centered">
      <div class="card is-6">
        <header class="card-header" v-bind:class="status.backgroundColor">
          <p class="card-header-title is-centered" v-bind:class="status.textColor">{{ status.text }}
            <span class="icon">
              <i :class="status.icon" aria-hidden="true"></i>
            </span>
          </p>
        </header>
        <b-loading :is-full-page="false" :active.sync="isLoadingFile" :can-cancel="true"></b-loading>
        <div class="card-image">
          <figure class="image" v-if="attachedUrl">
            <img :src=attachedUrl>
          </figure>
          <div v-else-if="!isLoadingFile && (payment.status === 'pending' || payment.status === 'waiting_transfer')">
            <b-field class="has-text-centered is-fullwidth">
              <b-upload v-model="files" drag-drop native>
                <section class="section">
                  <div class="content has-text-centered">
                    <p><b-icon icon="upload" size="is-medium"></b-icon></p>
                    <p>แนบหลักฐานที่นี่</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <b-field>
                <div class="tags is-centered">
                    <span v-for="(file, index) in files"
                        :key="index"
                        class="tag is-primary" >
                        {{ file.name }}
                        <button class="delete is-small"
                            type="button"
                            @click="deleteDropFile(index)">
                        </button>
                    </span>
                </div>
              </b-field>
            <button class="button is-emerald is-fullwidth"
                :class="{ 'is-loading' : isUploading }"
                @click="uploadFile(files[0])"
                :disabled="files.length === 0">
                ส่งหลักฐานการชำระเงิน
              </button>
          </div>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left" v-show="user.photoURL && !isAdmin">
              <figure class="image is-48x48">
                <img :src=user.photoURL class="circle" />
              </figure>
            </div>
            <div class="media-content">
              <p class="title is-4" v-show="!isAdmin">{{ user.displayName }}</p>
              <p class="subtitle is-6">{{ payment['user_email'] }}</p>
            </div>
          </div>
          <div class="content">
            <header class="card-header">
              <a class="card-header-title">หมายเลขอ้างอิง</a>
              <p class="card-header-icon">{{ payment.id }}</p>
            </header>
            <header class="card-header" v-show="payment.referenceId">
              <a class="card-header-title">รหัสอ้างอิงจากหลักฐาน</a>
              <p class="card-header-icon">{{ payment.referenceId }}</p>
            </header>
            <header class="card-header">
              <a class="card-header-title">จำนวนเงิน</a>
              <a class="card-header-icon">{{ payment.amount }} ฿</a>
            </header>
            <header class="card-header">
              <a class="card-header-title">วันที่ทำรายการ</a>
              <p class="card-header-icon">
                <time datetime="2016-1-1">{{ dateFormatted(payment.date) }}</time>
              </p>
            </header>
            <p></p>
            <p class="title is-4">{{ novel.name }}</p>
            <p class="subtitle is-6">{{ subscriptionName }}</p>
            <ul>
              <li v-for="attr in subscription.attributes" :key="attr">
                {{ attr }}
              </li>
            </ul>
            <div class="buttons" v-show="hasContact && (payment.status === 'pending' || payment.status === 'waiting_transfer' )">
              <a class="button is-primary is-fullwidth" href="https://m.me/xianni.thai">ติดต่อผ่าน Facebook</a>
              <a class="button is-emerald is-fullwidth" href="http://line.me/ti/p/~@read-thai">ติดต่อผ่าน Line</a>
              <a class="button is-info is-fullwidth" href="/">กลับหน้าแรก</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import { db, storage } from '@/firebase.config'

export default {
  props: {
    payment: Object,
    hasContact: Boolean,
    novel: Object,
    subscription: Object
  },
  data () {
    return {
      files: [],
      attachedUrl: null,
      isUploading: false,
      isLoadingFile: true
    }
  },
  computed: {
    user: get('user'),
    isAdmin: get('isAdmin'),
    status () {
      switch (this.payment.status) {
        case 'waiting_transfer':
          return {
            text: 'ขาดหลักฐานการชำระเงิน',
            textColor: 'has-text-black',
            backgroundColor: 'has-background-warning',
            icon: 'fas fa-image'
          }
        case 'refunded':
          return {
            text: 'ยกเลิกรายการ',
            textColor: 'has-text-white',
            backgroundColor: 'has-background-danger',
            icon: 'fas fa-ban'
          }
        case 'completed':
          return {
            text: 'เสร็จสมบูรณ์',
            textColor: 'has-text-white',
            backgroundColor: 'has-background-emerald',
            icon: 'fas fa-check'
          }
        default: return {
          text: 'รออนุมัติ',
          textColor: 'has-text-white',
          backgroundColor: 'has-background-info',
          icon: 'far fa-clock'
        }
      }
    },
    donateTotal () {
      var completedPayments = this.$root.payments.filter(payment => payment.status === 'completed')
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    },
    subscriptionName () {
      if (this.subscription.name.startsWith('เลื่อนขั้น')) {
        return this.subscription.name
      }
      return (this.subscription.price > this.donateTotal ? 'เลื่อน' : '') + this.subscription.name
    }
  },
  methods: {
    uploadFile (file) {
      this.isUploading = true
      storage.child('payments/images/' + this.payment.id)
        .put(file)
        .then(snapshot => {
          this.$toast.open({ message: 'Uploaded image successfuly!' })
          this.loadPaymentFile()
          db.collection('payments')
            .doc(this.payment.id)
            .update({ status: 'pending' })
          this.payment.status = 'pending'
          this.isUploading = false
        })
        .catch(error => {
          this.isUploading = false
          this.$toast.open({ message: `Uploading got an error: ${error.code}` })
        })
    },
    loadPaymentFile () {
      if (this.attachedUrl) {
        this.isLoadingFile = false
        return
      }
      this.isLoadingFile = true
      storage.child('payments/images/' + this.payment.id)
        .getDownloadURL()
        .then(url => {
          this.isLoadingFile = false
          this.attachedUrl = url
        })
        .catch(() => {
          this.isLoadingFile = false
        })
    },
    deleteDropFile (index) {
      this.files.splice(index, 1)
    },
    dateFormatted (date) {
      var options = { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }
      return date.toDate().toLocaleDateString('en-GB', options)
    }
  },
  mounted () {
    if (this.payment.status === 'refunded') {
      this.isLoadingFile = false
      return
    }
    this.loadPaymentFile()
  },
  watch: {
    files (newFile, oldFile) {
      if (newFile.length <= 0) { return }
      this.$root.$dialog.confirm({
        title: 'ท่านได้เลือกหลักฐานการโอนเข้ามาแล้ว',
        message: 'ต้องการอัพโหลดรูปเข้าระบบเลยหรือไม่?',
        confirmText: 'อัพโหลดหลักฐาน',
        cancelText: 'ยังไม่ต้องการ',
        onConfirm: () => { this.uploadFile(newFile[0]) }
      })
    },
    payment (newValue, oldValue) {
      if (newValue.status.includes('completed')) {
        this.$root.$dialog.confirm({
          type: 'is-success',
          title: 'ตรวจสอบเสร็จเรียบร้อย!',
          message: 'หลักฐานของท่านผ่านการตรวจสอบ หากไม่ถูกต้องกรุณาแจ้งผู้ดูแล \n ต้องการไปหน้าสารบัญนิยายเลยหรือไม่?',
          confirmText: 'ไปหน้าสารบัญ',
          onConfirm: () => { this.$root.$router.push({ name: 'novel', params: { novelId: this.novel.id } }) }
        })
      }
    }
  }
}
</script>
